import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const sendEmail = () => {
    emailjs.send(
      "service_faxxqjh",
      "template_2c2k6or",
      {
        from_name: form.name,
        from_email: form.email,
        message: form.message,
      },
      "6S8XFal8vTKJxAnex" // public key
    )
      .then(() => {
        alert("Message sent successfully 🚀");
        setForm({ name: "", email: "", message: "" });
      })
      .catch(() => {
        alert("Failed to send message ❌");
      });
  };
  return (
    <Box
      sx={{
        py: 10,
        px: 3,
        backgroundColor: "#ffff",
        color: "#000",
      }}
      id = "contact"
    >
      <Box maxWidth="700px" mx="auto">

        {/* TITLE */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Typography variant="h4" sx={{ fontWeight: "bold", textAlign: "center" }}>
            Contact Me
          </Typography>

          <Typography sx={{ textAlign: "center", color: "#aaa", mt: 1, mb: 5 }}>
            Let’s work together 🚀
          </Typography>
        </motion.div>

        {/* FORM */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Box
            sx={{
              backgroundColor: "#0000",
              p: 4,
              borderRadius: 3,
              boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
            }}
          >
            <TextField
              fullWidth
              label="Name"
              name="name"
              variant="outlined"
              onChange={handleChange}
              sx={{
                mb: 2,
                input: { color: "#000" },
                label: { color: "#000" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#333" },
                },
              }}
            />

            <TextField
              fullWidth
              label="Email"
              name="email"
              variant="outlined"
              onChange={handleChange}
              sx={{
                mb: 2,
                input: { color: "#000" },
                label: { color: "#000" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#333" },
                },
              }}
            />

            <TextField
              fullWidth
              label="Message"
              name="message"
              multiline
              rows={4}
              onChange={handleChange}
              sx={{
                mb: 3,
                textarea: { color: "#000" },
                label: { color: "#000" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#333" },
                },
              }}
            />

            <Button
              fullWidth
              variant="contained"
              onClick={sendEmail}
              sx={{
                backgroundColor: "#fff",
                color: "#000",
                fontWeight: "bold",
                py: 1.5,
                "&:hover": { backgroundColor: "#ddd" },
              }}
            >
              Send Message
            </Button>
          </Box>
        </motion.div>

      </Box>
    </Box>
  );
};

export default Contact;